import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider.jsx";

export function ProtectedRoute() {
  const auth = useAuth();
  const location = useLocation();

  if (auth.status === "loading") {
    return <AuthStatusPage label="Проверяем сессию" />;
  }
  if (auth.status !== "authenticated") {
    return <Navigate replace to="/login" state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}

export function AuthStatusPage({ label }) {
  return (
    <main className="auth-status" aria-live="polite" aria-busy="true">
      <span className="auth-status__brand">AXONLEADS</span>
      <div className="auth-status__signal" aria-hidden="true" />
      <p>{label}</p>
    </main>
  );
}
